import {useState} from 'react'
export default function ABC(){
  const data1={
    "x-label":[0,5,10,15,20,25],
    "y-label":[25,20,15,10,5,0],
    "max":25,
    item:[
      {x:0,y:0},
      {x:5,y:10},
      {x:10,y:15},
      {x:20,y:20}
    ]
  }
  const data2={
    "x-label":[-15,-10,-5,0,5,10,15],
    "y-label":[15,10,5,0,-5,-10,-15],
    "max":15,
    item:[
      {x:5,y:5},
      {x:0,y:0},
      {x:-10,y:-5},
    ]
  }
  const [text1, setText1] = useState(JSON.stringify(data1.item))
  const [text1View, setText1View] = useState([{"x":0,"y":0},{"x":5,"y":10},{"x":10,"y":15},{"x":20,"y":20}])
  const [text2, setText2] = useState(JSON.stringify(data2.item))
  const [text2View, setText2View] = useState([{"x":5,"y":5},{"x":0,"y":0},{"x":-10,"y":-5}])  
  return (<>
    <b className='text-[9px]'>plot(+/+)</b>
    <div className='flex'>
      <div className='flex w-[200px]'>
        <div className='w-[18px]'>
        <div className='h-[148px] flex flex-col justify-between'>
        {data1['y-label'].map((x)=><div className='relative border-b border-gray-800 w-[3px] ml-auto'>
          <div className='absolute z-[2] text-[6px] top-[-4px] right-[4px]'>{x}</div> 
        </div> 
        )}
        </div> 
        </div>
        <div>
        <div className='relative'>
        <div className='absolute z-[0] top-[0px] w-[150px] h-[148px] flex flex-col justify-between'>
         {data1['x-label'].map((x,i)=><>{i==data1['x-label'].length-1?<div className='w-full border-t border-gray-200'></div>:<><div className='w-full border-t border-gray-200'></div>
        <div className='w-full border-t border-gray-100'></div>
        <div className='w-full border-t border-gray-100'></div>
        <div className='w-full border-t border-gray-100'></div>
        <div className='w-full border-t border-gray-100'></div> 
        </>}</>)}
        </div>
        <div className='absolute z-[1] w-[150px] h-[148px] flex justify-between'>
        {data1['y-label'].map((x,i)=><>{i==data1['y-label'].length-1?<div className='h-full border-r border-gray-200'></div>:<><div className='h-full border-r border-gray-200'></div>
        <div className='h-full border-r border-gray-100'></div>
        <div className='h-full border-r border-gray-100'></div>
        <div className='h-full border-r border-gray-100'></div>
        <div className='h-full border-r border-gray-100'></div> 
        </>}</>)}
        </div>
        <div className='absolute z-[2] w-[150px] h-[148px] flex justify-between'>
        <div className='relative z-[3] w-[150px] h-[147px]'>
        {text1View.map((x1)=> <div style={{left:`${Math.floor(x1.x/data1.max*150)-2.5}px`,bottom:`${Math.floor(x1.y/data1.max*150)-4.5}px`}} className={`absolute z-[3] rounded-full bg-[#606277] w-[4px] h-[4px]`}></div>)}
        <div className='border-l border-gray-800 h-full'></div>
        <div className='relative border-t border-gray-800 h-1 w-full'>
        <div className='absolute flex w-full justify-between'>{data1['x-label'].map((x)=>
        <div className='relative border-l border-gray-800 h-[2px]'> 
        <div className='absolute text-[6px] top-[2px] left-[-4px]'>{x}</div>
        </div>
        )}</div>
        </div>
        </div>
        </div>
        </div>
        </div>
      </div>
      <div className='flex flex-col'>
      <p className='text-[9px]'>json data:</p>
      <textarea
        className='text-input-width border border-gray-950 text-[9px] w-[150px] h-[70px] line-break'
        value={text1} placeholder='your data goes here' onChange={(e)=>setText1(e.target.value)} 
        rows='4'
      ></textarea>
      <button className='border border-gray-800 text-[9px] w-fit pl-[10px] pr-[10px] mt-[2px] hover:bg-gray-100' onClick={()=>setText1View(JSON.parse(text1))}>apply</button>
      <div className='text-[9px]'>
        view:<br/> {typeof text1View !='string' && text1View != ''?<>{text1View.map(x=><div>x:{x.x} y:{x.y}</div>)}</> :''}
      </div>
      </div>
    </div>
    <b className='text-[9px]'>plot(+-/+-)</b>
    <div className='flex'>
    <div className='flex w-[200px]'>
    <div className='ml-[15px]'>
    <div className='relative w-[180px] h-[180px]'>
    {/* line */}
    <div className='absolute z-[0] top-[0px] w-[180px] h-[180px] flex flex-col justify-between'>
    {data2['x-label'].map((x,i)=><>{i==data2['x-label'].length-1?<div className='w-full border-t border-gray-200'></div>:<><div className='w-full border-t border-gray-200'></div>
    <div className='w-full border-t border-gray-100'></div>
    <div className='w-full border-t border-gray-100'></div>
    <div className='w-full border-t border-gray-100'></div>
    <div className='w-full border-t border-gray-100'></div> 
    </>}</>)}
    </div>
    <div className='absolute z-[1] w-[180px] h-[178px] flex justify-between'>
    {data2['y-label'].map((x,i)=><>{i==data2['y-label'].length-1?<div className='h-full border-r border-gray-200'></div>:<><div className='h-full border-r border-gray-200'></div>
    <div className='h-full border-r border-gray-100'></div>
    <div className='h-full border-r border-gray-100'></div>
    <div className='h-full border-r border-gray-100'></div>
    <div className='h-full border-r border-gray-100'></div> 
    </>}</>)}
    </div>
    {/* mein line */}
    <div className={`absolute z-[2] top-[89.5px] left-0 w-[180px] border-b border-gray-800`}></div>
    <div className='absolute z-[2] top-0 left-[89.5px] h-[180px] border-r border-gray-800'></div>
    {/* label */}
    <div className='absolute z-[2] w-[180px] top-[88px] left-0 flex justify-between'>{data2['x-label'].map((x,i)=>
    <div className='relative border-l border-gray-800 w-[1px] h-[4px]'><div className='absolute z-[2] text-[6px] top-[4px] left-[-4px]'>{x}</div></div>
    )}</div>
    <div className='absolute z-[2] h-[180px] top-0 left-[88px] flex flex-col justify-between'>{data2['y-label'].map((x,i)=>
    <div className='relative border-t border-gray-800 h-[1px] w-[4px]'><div className='absolute text-[6px] top-[-5px] left-[6px]'>{x}</div></div>)}
    </div>
    {/* dot */}
    {text2View.map((x1)=><div 
     style={{top:-(x1.x)<0?`${Math.floor((180/2)-((180/30)*x1.x))}px`:`${Math.floor((180/2)-((180/30)*x1.x))}px`, left:-(x1.y)<0?`${Math.floor((180/2)+((180/30)*x1.y))}px`:`${Math.floor((180/2)+((180/30)*x1.y))}px`}}
    className={`absolute z-[3] rounded-full bg-[#606277] w-[4px] h-[4px]`}></div>)}
    </div>
    </div>
    </div>
    <div className='flex flex-col'>
      <p className='text-[9px]'>json data:</p>
      <textarea
        className='text-input-width border border-gray-950 text-[9px] w-[150px] h-[70px] line-break'
        value={text2} placeholder='your data goes here' onChange={(e)=>setText2(e.target.value)} 
        rows='4'
      ></textarea>
      <button className='border border-gray-800 text-[9px] w-fit pl-[10px] pr-[10px] mt-[2px] hover:bg-gray-100' onClick={()=>setText2View(JSON.parse(text2))}>apply</button>
      </div>
    </div>
    </>)
}